import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from '@services/customers/customer.service';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { CustomerSelectionComponent } from '../../../../../components/popUpSelects/customer-selection/customer-selection.component';
import { OrganisationSelectionComponent } from '../../../../../components/popUpSelects/organisation-selection/organisation-selection.component';

@Component({
  selector: 'composition-wizard-customer-select',
  templateUrl: './composition-wizard-customer-select.component.html',
  styleUrls: ['./composition-wizard-customer-select.component.scss'],
  providers: [CustomerService, OrganisationCustomerService],
  standalone: false
})
export class CompositionWizardCustomerSelectComponent implements OnInit {

  public customerType = true;
  public entranceType: string;
  public selectedCustomerId: string = null;
  public customer = null;
  public readonly = false;
  public noCategories = false;
  public ownerOrganisationID = null;
  public edit = false;

  public entranceTypes = [
    { value: 'information', title: 'Information' }, { value: 'activity', title: 'Activity' }, { value: 'alphabet', title: 'Alphabet' },
    { value: 'breaking-news', title: 'Breaking News' }, { value: 'event', title: 'Event' }, { value: 'feedback', title: 'Feedback' }, { value: 'gallery', title: 'Gallery' },
    { value: 'gastronomy', title: 'Gastronomy' }, { value: 'offer', title: 'Offer' }, { value: 'opening-hours', title: 'Öffnungszeiten' }, { value: 'person', title: 'Person' },
    { value: 'pinboard', title: 'Pinboard' }, { value: 'quiz', title: 'Quiz' }, { value: 'restaurant', title: 'Restaurant' }, { value: 'roomservice', title: 'Room Service' },
    { value: 'screensaver', title: 'Screensaver' }, { value: 'social-media', title: 'Social Media' }, { value: 'ticker', title: 'Ticker' }, { value: 'voting', title: 'Voting' },
    { value: 'voucher', title: 'Voucher' }, { value: 'webcam', title: 'Webcams' }, { value: 'important-numbers', title: 'Wichtige Nummern' }
  ]

  constructor(
    public dialogRef: MatDialogRef<CompositionWizardCustomerSelectComponent>, public customerService: CustomerService,
    public organisationCustomerService: OrganisationCustomerService, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit() {
    if (!!this.data) { // edit
      this.customerType = !!this.data.id;
      this.selectedCustomerId = this.data.id;
      this.entranceType = this.data.type;
      this.edit = true;
      this.readonly = this.data.readonly;
      this.noCategories = this.data.noCategories;
      this.ownerOrganisationID = this.data.ownerOrganisationID

      this.fetchCustomer();
    } else { // create
      this.data = {};
      this.entranceType = 'information';
    }
  }

  async assignCustomer() {
    let dialogRef: MatDialogRef<CustomerSelectionComponent>;
    const config: MatDialogConfig = { data: { ids: [this.selectedCustomerId], type: 'organisationCustomer' } };
    dialogRef = this.dialog.open(CustomerSelectionComponent, config);
    const result = await dialogRef.afterClosed().toPromise();
    if (result) {
      this.customerType = result.customerType;
      this.selectedCustomerId = result.customerId;
      this.customer = null;
      this.fetchCustomer();
    }
  }

  async assignOrganisation() {
    let dialogRef: MatDialogRef<OrganisationSelectionComponent>;
    dialogRef = this.dialog.open(OrganisationSelectionComponent, {});
    const result = await dialogRef.afterClosed().toPromise();
    if (result) {
      this.ownerOrganisationID = result.OrganisationID;
    }
  }

  removeCustomer(event) {
    this.customerType = !event?.checked
    if (event?.checked) {
      this.selectedCustomerId = null;
      this.customer = null;
    }
  }

  save() {
    this.dialogRef.close({
      customerId: this.selectedCustomerId, customerType: this.customerType, entranceType: this.entranceType, readonly: this.readonly, noCategories: this.noCategories,
      ownerOrganisationID: this.ownerOrganisationID, config: this.data.config
    });
  }

  private async fetchCustomer() {
    const organisationCustomer = await this.organisationCustomerService.find(0, 1, { _id: this.selectedCustomerId });
    if (organisationCustomer.data && organisationCustomer.data.length) {
      return this.customer = organisationCustomer.data[0].organisationName;
    }
    const customer = await this.customerService.find(0, 1, { _id: this.selectedCustomerId });
    if (customer?.data?.length) {
      this.customer = customer.data[0].company;
    }
  }
}
